import { render, staticRenderFns } from "./fccVagasReservadasPadrao.vue?vue&type=template&id=0461cb0c"
import script from "./fccVagasReservadasPadrao.vue?vue&type=script&lang=js"
export * from "./fccVagasReservadasPadrao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports